import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Code = styled(Typography)`
  font-size: 1.125rem;
`;
